const MAX_EXPLICIT_ENTRIES = 3;

const formatEntityList = (entries: string[] = [], explicitAmount = MAX_EXPLICIT_ENTRIES) => {
  const explicitEntries = entries.slice(0, explicitAmount);
  const list = explicitEntries.join(', ');
  const implicitCount = entries.length - explicitAmount;
  return `${list}${implicitCount > 0 ? ` +${implicitCount}` : ''}`;
};

export default formatEntityList;
